import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-campo-textarea',
  standalone: true,
  imports: [],
  templateUrl: './campo-textarea.component.html',
  styleUrl: './campo-textarea.component.css',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampoTextareaComponent), multi: true }
  ]
})
export class CampoTextareaComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() erro = '';
  @Input() disabled = false;
  @Input() maxLength = 250;
  @Input() linhas = 4;

  valor = '';
  tocado = false;

  private onChange: (value: string) => void = () => { /* */ };
  private onTouched: () => void = () => { /**/ };

  writeValue(value: string): void {
    this.valor = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  aoDigitar(valor: string) {
    this.valor = valor;
    this.onChange(valor);
  }

  aoTocar() {
    this.tocado = true;
    this.onTouched();
  }

  get totalCaracteres(): number {
    return this.valor?.length ?? 0;
  }
}
